module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki03_pc-0ffb62948db03ddfcf704e56c1144edd.jpg";